// 審査状況照会のラベル
export const LABELS = {
  SERVICE_NAME: "サービス名",
  EXAMINATION_STATUS: "審査状況",
  COMPREHENSIVE_RESULT: "総合判定結果",
  EN_ROUTE_RESULT: "途上審査",
  NTT_FIXED_CREDIT: "NTT-F",
  VM_ORDER_TARGET_CODE: "V/M仕向け先",
  DETAIL_SEARCH: "詳細検索",
  CORPORATE_INFO: "法人情報",
  CORPORATE_NUMBER: "法人番号",
  COMPANY: "事業者名",
  CHECK_TARGET_CONDITION: "確認対象状況",
  MERCHANT_APPLICATION_CONDITION: "加盟店審査申請状況",
  APPLICATION_DATE: "審査申請日",
  BLANK: "　",
  WAVE: "～",
  CONTRACT_ROUTE: "契約ルート",
  ORDER_TARGET: "仕向け先",
  V_M: "V/M",
  SMCC: "SMCC",
  TF: "TF",
  SAISON: "セゾン",
  JCB: "JCB",
  AMEX: "AMEX",
  CLASSIFICATION: "審査申請区分",
  POS_REGISTRATION_CONDITION: "POS登録状況",
  REGISTRATION_DATE: "POS登録申請日",
  DOCOMO_EXAMINATION: "ドコモ審査",
  TITLE: "審査状況一覧",
  EXAMINATION_APPLICATION_NO: "審査申請No",
  APPLICATION_NO: "申請番号",
  APPLICATION_CLASSIFICATION: "申請区分",
  EXAMINATION_TYPE: "審査種別",
  COMPANY_NAME: "事業者名",
  MERCHANT_NAME: "加盟店名",
  EXAMINATION_REQUEST_UNIT: "審査依頼単位",
  SETTLEMENT_GROUP_ID: "決済グループID",
  ACCESS_KEY: "Access Key",
};
// 審査状況
export const EXAMINATION_STATUS = {
  BEFORE: "審査前",
  APPLYING: "審査中",
  COMPLETED: "審査完了",
};
// 総合判定結果
export const COMPREHENSIVE_RESULT_STATUS = {
  OK: "審査OK",
  NG: "審査NG",
  WAITING_FOR_REQUEST: "依頼待ち",
  APPROVAL_PENDING: "承認待ち",
};
// VM仕向け先
export const VM_ORDER_TARGET_CODE_STATUS = {
  DECIDED: "決定済み",
  UNDECIDED: "未決定",
};
//途上審査
export const EN_ROUTE_RESULT_STATUS = {
  ADS_NG: "審査NG（ADS）",
  OMNI_NG: "審査NG（omni）",
};
// 契約ルート
export const CONTRACT_ROUTE = {
  ALL: "全て",
  DIRECT: "直接",
  COMPREHENSION: "包括",
};
// 仕向け先
export const ORDER_TARGET = {
  ALL: "全て",
  NOT_NTT_D: "旧ルート",
  NTT_D: "NTTデータ",
  CREDIT: "クレカ",
  GMO: "GMOPG",
};
// 審査申請区分
export const CLASSIFICATION = {
  NORMAL_APPLICATION: "通常審査",
  TENANT_EXAMINATION: "店子審査",
  MONTHLY_CREDIT: "月次定クレカ",
};
//審査種別
export const EXAMINATION_TYPE = {
  NEW_EXAMINATION: "新規審査",
  CHANGE_EXAMINATION: "変更審査",
  CANCELLATION: "解約",
};
// POS登録状況
export const POS_REGISTRATION_CONDITION = {
  BEFORE: "申請前",
  APPLYING: "申請中",
  COMPLETED: "申請完了",
};
// プレースホルダー
export const PLACE_HOLDER = {
  NUM_LENGTH_THIRTEEN: "半角数字13桁以内",
  CHAR_LENGTH_THIRTY: "30文字以内",
  CHAR_LENGTH_FIFTEEN: "100文字以内",
  DATE_FORMAT: "YYYY/MM/DD",
  CHAR_LENGTH_TWENTY_SIX: "半角英数字26桁以内",
  DELIMITED_BY_COMMA: ",で複数指定可",
  EXAMINATION_APPLICATION_NO: "審査申請No1,審査申請No2,…",
  APPLICATION_NO: "申請番号1,申請番号2,…",
};
